// TODO: better import syntax?
import {BaseAPIRequestFactory, RequiredError, COLLECTION_FORMATS} from './baseapi';
import {Configuration} from '../configuration';
import {RequestContext, HttpMethod, ResponseContext, HttpFile} from '../http/http';
import {ObjectSerializer} from '../models/ObjectSerializer';
import {ApiException} from './exception';
import {canConsumeForm, isCodeInRange} from '../util';
import {SecurityAuthentication} from '../auth/auth';


import { Leaderboard } from '../models/Leaderboard';
import { LeaderboardRequest } from '../models/LeaderboardRequest';
import { PaginatedLeaderboardList } from '../models/PaginatedLeaderboardList';
import { PatchedLeaderboardRequest } from '../models/PatchedLeaderboardRequest';

/**
 * no description
 */
export class LeaderboardApiRequestFactory extends BaseAPIRequestFactory {

    /**
     * @param leaderboardRequest 
     */
    public async leaderboardCreate(leaderboardRequest: LeaderboardRequest, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;

        // verify required parameter 'leaderboardRequest' is not null or undefined
        if (leaderboardRequest === null || leaderboardRequest === undefined) {
            throw new RequiredError("LeaderboardApi", "leaderboardCreate", "leaderboardRequest");
        }


        // Path Params
        const localVarPath = '/api/leaderboard/';

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


        // Body Params
        const contentType = ObjectSerializer.getPreferredMediaType([
            "application/json",
        
            "application/x-www-form-urlencoded",
        
            "multipart/form-data"
        ]);
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = ObjectSerializer.stringify(
            ObjectSerializer.serialize(leaderboardRequest, "LeaderboardRequest", ""),
            contentType
        );
        requestContext.setBody(serializedBody);

        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * @param id A unique integer value identifying this leader board.
     */
    public async leaderboardDestroy(id: number, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new RequiredError("LeaderboardApi", "leaderboardDestroy", "id");
        }


        // Path Params
        const localVarPath = '/api/leaderboard/{id}/'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * @param intervalType 
     * @param intervalValue 
     * @param metric 
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @param user 
     * @param year 
     */
    public async leaderboardList(intervalType?: Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>, intervalValue?: number, metric?: Array<'DISTANCE' | 'SESSIONS' | 'TIME'>, page?: number, pageSize?: number, user?: number, year?: number, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;








        // Path Params
        const localVarPath = '/api/leaderboard/';

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
        if (intervalType !== undefined) {
            requestContext.setQueryParam("interval_type", ObjectSerializer.serialize(intervalType, "Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>", ""));
        }

        // Query Params
        if (intervalValue !== undefined) {
            requestContext.setQueryParam("interval_value", ObjectSerializer.serialize(intervalValue, "number", ""));
        }

        // Query Params
        if (metric !== undefined) {
            requestContext.setQueryParam("metric", ObjectSerializer.serialize(metric, "Array<'DISTANCE' | 'SESSIONS' | 'TIME'>", ""));
        }

        // Query Params
        if (page !== undefined) {
            requestContext.setQueryParam("page", ObjectSerializer.serialize(page, "number", ""));
        }

        // Query Params
        if (pageSize !== undefined) {
            requestContext.setQueryParam("page_size", ObjectSerializer.serialize(pageSize, "number", ""));
        }

        // Query Params
        if (user !== undefined) {
            requestContext.setQueryParam("user", ObjectSerializer.serialize(user, "number", ""));
        }

        // Query Params
        if (year !== undefined) {
            requestContext.setQueryParam("year", ObjectSerializer.serialize(year, "number", ""));
        }


        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * @param id A unique integer value identifying this leader board.
     * @param patchedLeaderboardRequest 
     */
    public async leaderboardPartialUpdate(id: number, patchedLeaderboardRequest?: PatchedLeaderboardRequest, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new RequiredError("LeaderboardApi", "leaderboardPartialUpdate", "id");
        }



        // Path Params
        const localVarPath = '/api/leaderboard/{id}/'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


        // Body Params
        const contentType = ObjectSerializer.getPreferredMediaType([
            "application/json",
        
            "application/x-www-form-urlencoded",
        
            "multipart/form-data"
        ]);
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = ObjectSerializer.stringify(
            ObjectSerializer.serialize(patchedLeaderboardRequest, "PatchedLeaderboardRequest", ""),
            contentType
        );
        requestContext.setBody(serializedBody);

        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * @param id A unique integer value identifying this leader board.
     */
    public async leaderboardRetrieve(id: number, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new RequiredError("LeaderboardApi", "leaderboardRetrieve", "id");
        }


        // Path Params
        const localVarPath = '/api/leaderboard/{id}/'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * @param leaderboardRequest 
     * @param intervalType 
     * @param intervalValue 
     * @param metric 
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @param user 
     * @param year 
     */
    public async leaderboardSetLeaderboardLast30DaysCreate(leaderboardRequest: LeaderboardRequest, intervalType?: Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>, intervalValue?: number, metric?: Array<'DISTANCE' | 'SESSIONS' | 'TIME'>, page?: number, pageSize?: number, user?: number, year?: number, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;

        // verify required parameter 'leaderboardRequest' is not null or undefined
        if (leaderboardRequest === null || leaderboardRequest === undefined) {
            throw new RequiredError("LeaderboardApi", "leaderboardSetLeaderboardLast30DaysCreate", "leaderboardRequest");
        }









        // Path Params
        const localVarPath = '/api/leaderboard/set-leaderboard-last-30-days/';

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
        if (intervalType !== undefined) {
            requestContext.setQueryParam("interval_type", ObjectSerializer.serialize(intervalType, "Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>", ""));
        }

        // Query Params
        if (intervalValue !== undefined) {
            requestContext.setQueryParam("interval_value", ObjectSerializer.serialize(intervalValue, "number", ""));
        }

        // Query Params
        if (metric !== undefined) {
            requestContext.setQueryParam("metric", ObjectSerializer.serialize(metric, "Array<'DISTANCE' | 'SESSIONS' | 'TIME'>", ""));
        }

        // Query Params
        if (page !== undefined) {
            requestContext.setQueryParam("page", ObjectSerializer.serialize(page, "number", ""));
        }

        // Query Params
        if (pageSize !== undefined) {
            requestContext.setQueryParam("page_size", ObjectSerializer.serialize(pageSize, "number", ""));
        }

        // Query Params
        if (user !== undefined) {
            requestContext.setQueryParam("user", ObjectSerializer.serialize(user, "number", ""));
        }

        // Query Params
        if (year !== undefined) {
            requestContext.setQueryParam("year", ObjectSerializer.serialize(year, "number", ""));
        }


        // Body Params
        const contentType = ObjectSerializer.getPreferredMediaType([
            "application/json",
        
            "application/x-www-form-urlencoded",
        
            "multipart/form-data"
        ]);
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = ObjectSerializer.stringify(
            ObjectSerializer.serialize(leaderboardRequest, "LeaderboardRequest", ""),
            contentType
        );
        requestContext.setBody(serializedBody);

        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * @param leaderboardRequest 
     * @param intervalType 
     * @param intervalValue 
     * @param metric 
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @param user 
     * @param year 
     */
    public async leaderboardSetMonthlyLeaderboardCreate(leaderboardRequest: LeaderboardRequest, intervalType?: Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>, intervalValue?: number, metric?: Array<'DISTANCE' | 'SESSIONS' | 'TIME'>, page?: number, pageSize?: number, user?: number, year?: number, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;

        // verify required parameter 'leaderboardRequest' is not null or undefined
        if (leaderboardRequest === null || leaderboardRequest === undefined) {
            throw new RequiredError("LeaderboardApi", "leaderboardSetMonthlyLeaderboardCreate", "leaderboardRequest");
        }









        // Path Params
        const localVarPath = '/api/leaderboard/set-monthly-leaderboard/';

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
        if (intervalType !== undefined) {
            requestContext.setQueryParam("interval_type", ObjectSerializer.serialize(intervalType, "Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>", ""));
        }

        // Query Params
        if (intervalValue !== undefined) {
            requestContext.setQueryParam("interval_value", ObjectSerializer.serialize(intervalValue, "number", ""));
        }

        // Query Params
        if (metric !== undefined) {
            requestContext.setQueryParam("metric", ObjectSerializer.serialize(metric, "Array<'DISTANCE' | 'SESSIONS' | 'TIME'>", ""));
        }

        // Query Params
        if (page !== undefined) {
            requestContext.setQueryParam("page", ObjectSerializer.serialize(page, "number", ""));
        }

        // Query Params
        if (pageSize !== undefined) {
            requestContext.setQueryParam("page_size", ObjectSerializer.serialize(pageSize, "number", ""));
        }

        // Query Params
        if (user !== undefined) {
            requestContext.setQueryParam("user", ObjectSerializer.serialize(user, "number", ""));
        }

        // Query Params
        if (year !== undefined) {
            requestContext.setQueryParam("year", ObjectSerializer.serialize(year, "number", ""));
        }


        // Body Params
        const contentType = ObjectSerializer.getPreferredMediaType([
            "application/json",
        
            "application/x-www-form-urlencoded",
        
            "multipart/form-data"
        ]);
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = ObjectSerializer.stringify(
            ObjectSerializer.serialize(leaderboardRequest, "LeaderboardRequest", ""),
            contentType
        );
        requestContext.setBody(serializedBody);

        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * @param leaderboardRequest 
     * @param intervalType 
     * @param intervalValue 
     * @param metric 
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @param user 
     * @param year 
     */
    public async leaderboardSetWeeklyLeaderboardCreate(leaderboardRequest: LeaderboardRequest, intervalType?: Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>, intervalValue?: number, metric?: Array<'DISTANCE' | 'SESSIONS' | 'TIME'>, page?: number, pageSize?: number, user?: number, year?: number, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;

        // verify required parameter 'leaderboardRequest' is not null or undefined
        if (leaderboardRequest === null || leaderboardRequest === undefined) {
            throw new RequiredError("LeaderboardApi", "leaderboardSetWeeklyLeaderboardCreate", "leaderboardRequest");
        }









        // Path Params
        const localVarPath = '/api/leaderboard/set-weekly-leaderboard/';

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
        if (intervalType !== undefined) {
            requestContext.setQueryParam("interval_type", ObjectSerializer.serialize(intervalType, "Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>", ""));
        }

        // Query Params
        if (intervalValue !== undefined) {
            requestContext.setQueryParam("interval_value", ObjectSerializer.serialize(intervalValue, "number", ""));
        }

        // Query Params
        if (metric !== undefined) {
            requestContext.setQueryParam("metric", ObjectSerializer.serialize(metric, "Array<'DISTANCE' | 'SESSIONS' | 'TIME'>", ""));
        }

        // Query Params
        if (page !== undefined) {
            requestContext.setQueryParam("page", ObjectSerializer.serialize(page, "number", ""));
        }

        // Query Params
        if (pageSize !== undefined) {
            requestContext.setQueryParam("page_size", ObjectSerializer.serialize(pageSize, "number", ""));
        }

        // Query Params
        if (user !== undefined) {
            requestContext.setQueryParam("user", ObjectSerializer.serialize(user, "number", ""));
        }

        // Query Params
        if (year !== undefined) {
            requestContext.setQueryParam("year", ObjectSerializer.serialize(year, "number", ""));
        }


        // Body Params
        const contentType = ObjectSerializer.getPreferredMediaType([
            "application/json",
        
            "application/x-www-form-urlencoded",
        
            "multipart/form-data"
        ]);
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = ObjectSerializer.stringify(
            ObjectSerializer.serialize(leaderboardRequest, "LeaderboardRequest", ""),
            contentType
        );
        requestContext.setBody(serializedBody);

        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * @param leaderboardRequest 
     * @param intervalType 
     * @param intervalValue 
     * @param metric 
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @param user 
     * @param year 
     */
    public async leaderboardSetYearlyLeaderboardCreate(leaderboardRequest: LeaderboardRequest, intervalType?: Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>, intervalValue?: number, metric?: Array<'DISTANCE' | 'SESSIONS' | 'TIME'>, page?: number, pageSize?: number, user?: number, year?: number, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;

        // verify required parameter 'leaderboardRequest' is not null or undefined
        if (leaderboardRequest === null || leaderboardRequest === undefined) {
            throw new RequiredError("LeaderboardApi", "leaderboardSetYearlyLeaderboardCreate", "leaderboardRequest");
        }









        // Path Params
        const localVarPath = '/api/leaderboard/set-yearly-leaderboard/';

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
        if (intervalType !== undefined) {
            requestContext.setQueryParam("interval_type", ObjectSerializer.serialize(intervalType, "Array<'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'>", ""));
        }

        // Query Params
        if (intervalValue !== undefined) {
            requestContext.setQueryParam("interval_value", ObjectSerializer.serialize(intervalValue, "number", ""));
        }

        // Query Params
        if (metric !== undefined) {
            requestContext.setQueryParam("metric", ObjectSerializer.serialize(metric, "Array<'DISTANCE' | 'SESSIONS' | 'TIME'>", ""));
        }

        // Query Params
        if (page !== undefined) {
            requestContext.setQueryParam("page", ObjectSerializer.serialize(page, "number", ""));
        }

        // Query Params
        if (pageSize !== undefined) {
            requestContext.setQueryParam("page_size", ObjectSerializer.serialize(pageSize, "number", ""));
        }

        // Query Params
        if (user !== undefined) {
            requestContext.setQueryParam("user", ObjectSerializer.serialize(user, "number", ""));
        }

        // Query Params
        if (year !== undefined) {
            requestContext.setQueryParam("year", ObjectSerializer.serialize(year, "number", ""));
        }


        // Body Params
        const contentType = ObjectSerializer.getPreferredMediaType([
            "application/json",
        
            "application/x-www-form-urlencoded",
        
            "multipart/form-data"
        ]);
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = ObjectSerializer.stringify(
            ObjectSerializer.serialize(leaderboardRequest, "LeaderboardRequest", ""),
            contentType
        );
        requestContext.setBody(serializedBody);

        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * @param intervalType Type of the interval
     * @param intervalValue 
     * @param metric Metric type
     * @param user 
     * @param year 
     */
    public async leaderboardUserLeaderboardList(intervalType?: 'DISTANCE' | 'SESSIONS' | 'TIME', intervalValue?: number, metric?: 'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR', user?: number, year?: number, _options?: Configuration): Promise<RequestContext> {
        let _config = _options || this.configuration;






        // Path Params
        const localVarPath = '/api/leaderboard/user-leaderboard/';

        // Make Request Context
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
        if (intervalType !== undefined) {
            requestContext.setQueryParam("interval_type", ObjectSerializer.serialize(intervalType, "'DISTANCE' | 'SESSIONS' | 'TIME'", ""));
        }

        // Query Params
        if (intervalValue !== undefined) {
            requestContext.setQueryParam("interval_value", ObjectSerializer.serialize(intervalValue, "number", ""));
        }

        // Query Params
        if (metric !== undefined) {
            requestContext.setQueryParam("metric", ObjectSerializer.serialize(metric, "'LAST_30_DAYS' | 'LAST_7_DAYS' | 'MONTH' | 'WEEK' | 'YEAR'", ""));
        }

        // Query Params
        if (user !== undefined) {
            requestContext.setQueryParam("user", ObjectSerializer.serialize(user, "number", ""));
        }

        // Query Params
        if (year !== undefined) {
            requestContext.setQueryParam("year", ObjectSerializer.serialize(year, "number", ""));
        }


        let authMethod: SecurityAuthentication | undefined;
        // Apply auth methods
        authMethod = _config.authMethods["tokenAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        // Apply auth methods
        authMethod = _config.authMethods["cookieAuth"]
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        
        const defaultAuth: SecurityAuthentication | undefined = _options?.authMethods?.default || this.configuration?.authMethods?.default
        if (defaultAuth?.applySecurityAuthentication) {
            await defaultAuth?.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

}

export class LeaderboardApiResponseProcessor {

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardCreate
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardCreate(response: ResponseContext): Promise<Leaderboard > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body: Leaderboard = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Leaderboard", ""
            ) as Leaderboard;
            return body;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: Leaderboard = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Leaderboard", ""
            ) as Leaderboard;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardDestroy
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardDestroy(response: ResponseContext): Promise<void > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("204", response.httpStatusCode)) {
            return;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: void = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "void", ""
            ) as void;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardList
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardList(response: ResponseContext): Promise<PaginatedLeaderboardList > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardPartialUpdate
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardPartialUpdate(response: ResponseContext): Promise<Leaderboard > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: Leaderboard = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Leaderboard", ""
            ) as Leaderboard;
            return body;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: Leaderboard = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Leaderboard", ""
            ) as Leaderboard;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardRetrieve
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardRetrieve(response: ResponseContext): Promise<Leaderboard > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: Leaderboard = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Leaderboard", ""
            ) as Leaderboard;
            return body;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: Leaderboard = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Leaderboard", ""
            ) as Leaderboard;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardSetLeaderboardLast30DaysCreate
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardSetLeaderboardLast30DaysCreate(response: ResponseContext): Promise<PaginatedLeaderboardList > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardSetMonthlyLeaderboardCreate
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardSetMonthlyLeaderboardCreate(response: ResponseContext): Promise<PaginatedLeaderboardList > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardSetWeeklyLeaderboardCreate
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardSetWeeklyLeaderboardCreate(response: ResponseContext): Promise<PaginatedLeaderboardList > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardSetYearlyLeaderboardCreate
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardSetYearlyLeaderboardCreate(response: ResponseContext): Promise<PaginatedLeaderboardList > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: PaginatedLeaderboardList = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "PaginatedLeaderboardList", ""
            ) as PaginatedLeaderboardList;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to leaderboardUserLeaderboardList
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async leaderboardUserLeaderboardList(response: ResponseContext): Promise<Array<Leaderboard> > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: Array<Leaderboard> = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Array<Leaderboard>", ""
            ) as Array<Leaderboard>;
            return body;
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: Array<Leaderboard> = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Array<Leaderboard>", ""
            ) as Array<Leaderboard>;
            return body;
        }

        throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers);
    }

}
